import { decodeToken } from '../utils/decodeToken';
export function getRemainingSeconds(token) {
  if (!token) {
    return 0;
  }
  const decoded = decodeToken(token);
  if (!decoded) {
    return 0;
  }
  const {
    exp
  } = decoded;
  const remaining = Math.floor(exp - Date.now() / 1000);
  return remaining < 0 ? 0 : remaining;
}
//# sourceMappingURL=getRemainingSeconds.js.map